export function smoothScrollToElemenHelper(
  target: HTMLElement,
  durationInMilliseconds = 800
) {
  const start = window.scrollY;
  const end = target.getBoundingClientRect().top + window.scrollY;
  const distance = end - start;
  const startTime = performance.now();

  function easeOutQuad(progressAnimate: number) {
    return progressAnimate * (2 - progressAnimate); // t = de 0 a 1
  }

  function scroll(currentTime: number) {
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / durationInMilliseconds, 1); // 0 até 1
    const ease = easeOutQuad(progress);

    window.scrollTo(0, start + distance * ease);

    if (progress < 1) {
      requestAnimationFrame(scroll);
    }
  }

  requestAnimationFrame(scroll);
}
